<template>
  <div class="manage-your-account-section">
    <div class="image-wrapper">
      <div class="image-bubbles">
        <img
          class="manage-your-account_image_accent-circle-yellow"
          src="@Shared/assets/images/small-yellow-circle.svg"
          alt="Small yellow circle"
        />
        <img
          class="manage-your-account_image"
          src="@Shared/assets/images/ed-unsplash.png"
          alt="Man looking at cellphone"
        />
        <img
          class="manage-your-account_image_accent-circle-green"
          src="@Shared/assets/images/GreenOval.svg"
          alt="Small green circle"
        />
      </div>
    </div>
    <div class="content-wrapper">
      <ManageYourAccount />
      <VerticalDivider class="manage-account-divider" style="height: 4px" />
      <LoginToOnlineBanking />
      <div class="circle-wrapper">
        <img
          class="login-to-olb_image-circle-blue"
          src="@Shared/assets/images/SmallBlueOval.svg"
          alt="Small blue circle"
        />
        <img
          class="login-to-olb_image-circle-orange"
          src="@Shared/assets/images/SmallOrangeOval.svg"
          alt="Small orange circle"
        />
        <div class="outer-circle">
          <div class="inner-circle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManageYourAccount from "./ManageYourAccount.vue";
import LoginToOnlineBanking from "./LoginToOnlineBanking.vue";
import VerticalDivider from "@Shared/components/VerticalDivider.vue";

export default {
  name: "ManageYourAccountSection",
  components: {
    ManageYourAccount,
    LoginToOnlineBanking,
    VerticalDivider,
  },
};
</script>

<style lang="scss" scoped>
.manage-your-account-section {
  display: grid;
  grid-template-columns: repeat(2, auto);
  margin: 5vh 10vh;

  @media all and (max-width: $grid-breakpoint-lg) {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 5%;
    margin: 0;
  }

  .manage-account-divider {
    @media all and (max-width: $grid-breakpoint-md) {
      margin: 20px 0;
    }
  }

  .content-wrapper {
    position: relative;
    margin-left: 15px;
    margin-right: 15px;
    padding-left: 50px;
    padding-right: 50px;

    @media all and (max-width: $grid-breakpoint-md) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  .circle-wrapper {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);

    .login-to-olb_image-circle-blue {
      position: absolute;
      z-index: 3;
      top: 10%;
      right: 85%;
    }

    .login-to-olb_image-circle-orange {
      position: absolute;
      z-index: 2;
      top: 25%;
      right: 94%;
    }

    .outer-circle {
      width: 279px;
      height: 279px;
      border-radius: 50%;
      background: linear-gradient(180deg, #0b5637 0%, #4fa800 100%);
      position: relative;
      z-index: 1;
    }

    .inner-circle {
      background: #ffffff;
      border-radius: 50%;
      width: 206px;
      height: 206px;
      position: relative;
      z-index: 1;
      top: 13%;
      left: 13%;
    }

    @media all and (max-width: $grid-breakpoint-lg) {
      display: none;
    }
  }

  .image-wrapper {
    display: flex;

    @media all and (max-width: $grid-breakpoint-lg) {
      justify-content: center;
    }

    .image-bubbles {
      position: relative;
      max-height: 403px;
      max-width: 403px;

      @media all and (max-width: $grid-breakpoint-md) {
        max-height: 370px;
        max-width: 370px;
      }

      .manage-your-account_image_accent-circle-yellow {
        position: absolute;
        top: 0px;
        left: 75%;
        z-index: 1;
        width: 132px;
        height: 132px;
        opacity: 0.5;

        @media all and (max-width: $grid-breakpoint-lg) {
          display: grid;
          grid-template-columns: 1fr;
          row-gap: 10%;
          margin: 0;
        }

        @media all and (max-width: $grid-breakpoint-md) {
          height: 102px;
          width: 102px;
        }
      }

      .manage-your-account_image_accent-circle-green {
        position: absolute;
        top: 80%;
        right: 75%;
        z-index: -1;
        width: 72px;
        height: 72px;

        @media all and (max-width: $grid-breakpoint-md) {
          height: 61px;
          width: 61px;
        }
      }

      .manage-your-account_image {
        position: relative;
        height: 403px;
        width: 403px;

        @media all and (max-width: $grid-breakpoint-md) {
          height: 330px;
          width: 330px;
        }
      }
    }
  }

  .align-content-manage-account {
    display: flex;
    flex-flow: column;
    margin: 5% 0px;
    padding-left: 5%;
    padding-right: 3%;
  }
}
</style>
